var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-0"},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":true}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }